export default class AppError {

    constructor(message) {
        this.message = message;
    }
}
